import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { RowSelectEventArgs } from '@syncfusion/ej2-react-grids';

export interface EncounterGridRow {
  id: string;
  visitNumber: string;
  [key: string]: unknown;
}

/**
 * Hook for handling encounter row selection and navigation
 */
export function useEncounterNavigation() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Get parameters from URL for navigation
  const company = searchParams.get('company') || '';
  const center = searchParams.get('center') || '';
  const mrn = searchParams.get('mrn') || '';

  const handleRowSelected = useCallback(
    (args: RowSelectEventArgs) => {
      const data = args.data as EncounterGridRow;
      if (data?.id) {
        navigate(`/encounterEdit?id=${encodeURIComponent(data.id)}&company=${encodeURIComponent(company)}&center=${encodeURIComponent(center)}&mrn=${encodeURIComponent(mrn)}`);
      }
    },
    [navigate, company, center, mrn]
  );

  return {
    handleRowSelected,
  };
}
